<template>
  <div>
    <modals-container name="modal1" />
    <!--课程概要-->
    <div class="box study_detail_top" :style="boxMargin">
      <div class="wrap w1200">
        <div class="tit" style="margin-bottom: 0;">
          <dl>
            <dt>
              首页-课件学习-{{classificationName}}-{{params.name}}
            </dt>
            <dd>
              <a class="back_btn" onclick="history.go(-1)">返回</a>
              <a href="javascript:;" title="收藏" @click="course_collectOrCancel(params.id, $event)" v-bind:class="[isCollect ? 'fav_focus' : 'fav']"></a><!--当点击变成已收藏，class值变成 fav_focus-->
              <!--<a href="javascript:;" title="分享" class="share"></a>-->
              <a title="评分" v-bind:class="[isEvaluate ? 'star' : 'star_go']"   href="javascript:void(0);"   @click="showEvaluate(isEvaluate)"></a>
            </dd>
          </dl>
        </div>
        <!--左侧课程图片-->
        <div class="col_1 w500 de_play">
          <!--视频-->
          <!--<div id="willesPlay" style="margin-top: -25px;">
            <div class="playContent" style="width: 500px;">
              <video width="500" height="284" id="playVideo" src="">当前浏览器不支持 video直接播放，点击这里下载视频： <a href="javascript:;">下载视频</a> </video>
              <div class="playTip glyphicon glyphicon-play"></div>
            </div>
            <div class="playControll">
              <div class="playPause playIcon"></div>
              <div class="timebar"> <span class="currentTime">0:00:00</span>
                <div class="progress" style="width: 70%;margin-left: 25px;">
                  <div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div>
                </div>
                <span class="duration">0:00:00</span> </div>
              <div class="otherControl"> <span class="volume glyphicon glyphicon-volume-down"></span> <span class="fullScreen glyphicon glyphicon-fullscreen"></span> </div>
            </div>
          </div>-->
          <!--/视频-->
          <img src="@/assets/images/shikan.jpg" alt="试看视频">
        </div>
        <!--/左侧课程图片-->
        <!--右侧课程介绍-->
        <div class="col_2 w645 de_con_top">
          <h3>{{classificationName}}</h3>
          <h2 class="single_ellipsis"><a style="color: white;" :title="params.name">{{params.name}}</a></h2>
          <div v-html="params.title"></div>
        </div>
        <!--/右侧课程介绍-->
        <div class="clear"></div>
        <div class="de_cat_all">
          <div class="col_1">
            <dl>
              <dt>视频时长</dt>
              <dd><span v-if="params.period">{{parseFloat(params.period/3600).toFixed(2)}}</span><span v-if="!params.period">0</span>小时</dd>
            </dl>
            <dl>
              <dt>课程节数</dt>
              <dd><span v-if="!params.chapterInfos">0</span><span v-if="params.chapterInfos">{{params.chapterInfos.length}}</span>章节</dd>
            </dl>
            <dl>
              <dt>学时</dt>
              <dd><span v-if="params.credit">{{params.credit}}</span><span v-else>0</span></dd>
            </dl>
            <dl>
              <dt>学习人数</dt>
              <dd><span>{{learnCnt}}</span>人</dd>
            </dl>
            <dl>
              <dt>讲师</dt>
              <dd>
                <b v-if="params.teacherList">{{params.teacherList[0].teacherName}}</b><a v-if="params.teacherList && params.teacherList.length>1">等</a>
                <b v-if="!params.teacherList">无</b>
              </dd>
            </dl>
          </div>
          <div class="col_2 cat_right">
            <dl v-if="!params.buy && !params.auth">
              <dt>
                <p>
                  <span v-if="params.coursePriceList && params.coursePriceList[0].price && params.coursePriceList[0].price != '0'">￥{{params.coursePriceList[0].price}}</span>
                  <span v-if="!params.coursePriceList || !params.coursePriceList[0].price || params.coursePriceList[0].price == '0'">￥0</span>
                </p>
                <p class="mt5">支持支付宝、微信支付</p>
              </dt>
              <dd>
                <a href="javascript:;" v-if="params.coursePriceList && params.coursePriceList[0].price && params.coursePriceList[0].price != '0'" @click="course_buy(params.id)">购买课程</a>
                <a href="javascript:;"
                   v-if="!params.coursePriceList || !params.coursePriceList[0].price || params.coursePriceList[0].price == '0'"
                   @click="continueLearn()">学习课程</a>
              </dd>
            </dl>
            <dl v-if="params.buy || params.auth"><!--已购买课程显示内容-->
              <dt>
                <h4 >您已学习<span>{{hasLearned}}</span>节课</h4>
              </dt>
              <dd>
                <a v-if="hasLearned!=0 && hasLearned==courseChapterList.length" href="javascript:;"
                   @click="continueLearn()">复习</a>
                <a v-if="allLearnCnt>0 && hasLearned!=courseChapterList.length" href="javascript:;"
                   @click="continueLearn()">继续学习</a>
                <a v-if="hasLearned==0 && allLearnCnt==0" href="javascript:;" @click="continueLearn()">开始学习</a>
              </dd>
            </dl>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!--/课程概要-->
    <!--课程介绍菜单-->
    <div class="wrap box study_detail_content" style="margin-bottom: 0" id="study_detail_content">
      <ul class="tabs" style="border-bottom: 0;">
        <li v-show="isLogined && (params.buy || params.auth)" class="tab1_1"><a href="javascript:;" name=".tab1_3">课程章节(<span v-if="!params.chapterInfos">0</span><span v-if="params.chapterInfos">{{params.chapterInfos.length}}</span>)</a></li>
        <li class="tab1_2"><a href="javascript:;" name=".tab1_4">课程介绍</a></li>
        <li class="tab1_3"><a href="javascript:;" name=".tab1_5">讲师介绍</a></li>
        <li class="tab1_4"><a href="javascript:;" name=".tab1_6">学员评价</a></li>
        <li class="tab1_5"><a href="javascript:;" name=".tab1_7">资料下载</a></li>
      </ul>
      <div class="tab_content">
        <!--课程介绍-->
        <div class="tab1_4 w1200 wrap">
          <p class="introduction_detail" v-html="params.introduction" style="padding: 15px;"></p>
        </div>
        <!--/课程介绍-->
        <!--讲师介绍-->
        <div class="tab1_5 w1200 wrap ">
          <ul class="js_con" v-for="item in teacherList" :key="item.id"  v-if="teacherList && teacherList.length>0">
            <dl class="video_more"><a href="javascript:;" @click="teacher_detail(item.id)"><img src="@/assets/images/study_jsjs_play@2x.png" title="观看讲师更多教学"/></a></dl>
            <dl class="about_js">
              <dt>{{item.name}}老师</dt>
              <dd v-html="item.content"></dd>
            </dl>
            <dl class="about_right">
              <dt><img v-if="item.faceUrl" :src="item.faceUrl" /><img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/teacher_normal_img.jpg" /><br />{{item.name}}</dt>
              <dd v-html="item.title"></dd>
            </dl>
          </ul>
        </div>
        <!--/讲师介绍-->
        <!--课程章节-->
        <div v-if="isLogined && (params.buy || params.auth)" class="tab1_3  zj_list w1200 wrap">
          <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tr v-for="(item, index) in courseChapterList" :key="item.id" :class="{'bgcolor': (index/2==0), '': (index/2!=0)}" >
              <span class="ch_course_item" v-if="item.sourceList">
                <span class="course_ch_course_icon"></span>
                <td class="sub_text" width="130" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left">第{{item.number}}节</td>
                <td class="sub_text" width="500" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left">{{item.name}}</td>
                <!--<td class="sub_text" width="160" :class="{'focus_item': (item.status=='1'), '': (item.status!='1')}" align="left" v-if="item.status!='0' && (courseBuyStatus=='1' || params.buy || params.auth)">上次播放:{{parseFloat(item.learnHour/60).toFixed(2)}}分钟</td>-->
                <td class="sub_text" width="160" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left">时长:{{parseFloat(item.allHour/60).toFixed(2)}}分钟</td>
                <td width="240" v-if="item.status=='2' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_end" href="javascript:;" @click="getChapterResource(params, item)">已学</a></td>
                <td width="240" v-if="item.status=='0' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_ing" href="javascript:;" @click="getChapterResource(params, item)">未学</a></td>
                <td width="240" v-if="item.status=='1' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_end" href="javascript:;" @click="getChapterResource(params, item)">学习中</a></td>
                <!--<td class="sub_text" width="100" v-if="item.status=='0' && (courseBuyStatus=='1' || params.buy || params.auth)"></td>
                <td class="sub_text" width="100" v-if="item.status!='0' && (courseBuyStatus=='1' || params.buy || params.auth)">上次播放:{{parseFloat(item.learnHour/60).toFixed(2)}}分钟</td>
                <td class="sub_text" width="100">时长:{{parseFloat(item.allHour/60).toFixed(2)}}分钟</td>
                <td v-if="item.status=='2' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_end" href="javascript:;" @click="getChapterResource(params, item)">已学</a></td>
                <td v-if="item.status=='0' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_ing" href="javascript:;" @click="getChapterResource(params, item)">未学</a></td>
                <td v-if="item.status=='1' && (courseBuyStatus=='1' || params.buy || params.auth)"><a class="s_end" href="javascript:;" @click="getChapterResource(params, item)">学习中</a></td>-->
              </span>
              <span class="ch_exam_item" v-if="item.examList">
                <span class="course_ch_exam_icon"></span>
                <td class="sub_text" width="130" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left">第{{item.number}}节</td>
                <td class="sub_text" width="500" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left">{{item.name}}</td>
                <td class="sub_text" width="160" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left" v-if="item.pass && item.pass == '1'">已通过</td>
                <td class="sub_text" width="160" :class="{'focus_item': (item.lastLearnLog=='1'), '': (item.lastLearnLog!='1')}" align="left" v-if="!item.pass || (item.pass && item.pass == '0')">未通过</td>
                <td width="180">
                  <a class="s_ing" style="display: inline-block;" href="javascript:;" @click="showQuiz(item)">开始测验</a>
                  <a style="display: inline-block;" class="s_ing" href="javascript:;" @click="showQuizResult(item)">查看结果</a>
                </td>
              </span>
            </tr>
          </table>
        </div>
        <!--/课程章节-->
        <!--学员评价-->
        <div class="tab1_6 box">
          <dl class="pj_top" >
            <table width="900" border="0" cellspacing="0" cellpadding="0" class="wrap">
              <tr>
                <td width="420"><p class="col_1">综合评分<span class="num_a" v-if="avgStar">{{avgStar}}</span></p>
                  <p class="s_col_a" v-if="avgStar" v-html="showStar(parseInt(avgStar))"></p>
                </td>
                <!--<td width="160">内容丰富<span class="num_b">10.0</span></td>
                <td width="160">教学易懂<span class="num_b">10.0</span></td>
                <td width="160">逻辑清晰<span class="num_b">10.0</span></td>-->
              </tr>
            </table>
          </dl>
          <dl class="ly_list">
            <table class="wrap w900" border="0" cellspacing="0" cellpadding="0">
              <tr v-for="item in evaluateList" :key="item.id">
                <td width="90" valign="top">
                  <img v-if="item.userHead" :src="item.userHead" class="h_img" style="margin-bottom:4px;"/>
                  <img v-if="!item.userHead || item.userHead==''" src="@/assets/images/teacher-avatar.png" class="h_img" style="margin-bottom:4px;"/>
                  <p class="userName" :title="item.nickname">{{item.nickname}}</p>
                </td>
                <!--<td width="960" valign="top">
                  <p class="name">{{item.userName}}</p>
                  &lt;!&ndash;<p class="ly_con">丢掉幻想，尽快解决核心技术，哪怕没有别家的先进，先解决“有”的问题，再谋求“好”的问题。不可再把宝押在别家身上了。</p>&ndash;&gt;
                </td>-->
                <td valign="top">
                  <p class="ly_star"><a v-html="showStar(parseInt(item.star))"></a><span>{{item.star}}分</span></p>
                  <p class="time" style="text-align: left;padding-left:5px;">时间：{{$utils.substring(item.createTime, 0, 10)}}</p>
                </td>
              </tr>
              <tr>
                <td width="80" valign="top" class="pagination_td"></td>
                <td valign="top" class="pagination_td">
                  <paginate :click-handler="clickCallback" :page-count=evaluatePages
                            :container-class=$global.paginationOptions.container_class_evaluate :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                            :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                            :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                            :first-last-button=$global.paginationOptions.first_last_button
                            :active-class=$global.paginationOptions.active_class
                            :disabled-class=$global.paginationOptions.disabled_class
                            :first-button-text=$global.paginationOptions.first_button_text
                            :last-button-text=$global.paginationOptions.last_button_text
                            :prev-text=$global.paginationOptions.prev_text
                            :next-text=$global.paginationOptions.next_text>
                  </paginate>
                </td>
                <td valign="top" class="pagination_td"></td>
              </tr>
            </table>
          </dl>
        </div>
        <!--/学员评价-->
        <!--资料下载-->
        <div class="tab1_7">
          <dl class="w1200 wrap down_list" v-if="params.attachment && params.attachment.length > 0">
            <a v-for="item in params.attachment.split(',')" :key="item.id" :href="item.split('|')[1]" target="_blank" style="width: auto; padding-left: 0; background: none;">{{item.split('|')[0]}}</a>
          </dl>
          <dl class="w1200 wrap down_list" v-else>暂无资料</dl>
        </div>
        <!--/资料下载-->
      </div>
    </div>
    <!--/课程介绍菜单-->
    <!--推荐课程滚动-->
    <div class="rdiv_scoll" style="position: relative; bottom:0">
      <div class="study_tj_tit">相关课程推荐</div>
      <div class="box kc_gd_bg">
        <div class="wrap w1200 rdiv lb_con">
          <span v-if="relativeCourses.length > 0" class="prev" @click="page_click('prev')">上一页</span>
          <span v-if="relativeCourses.length > 0" class="next" @click="page_click('next')">下一张</span>
          <div class="box_gd">
            <div class="gd_list" id="roll" v-if="relativeCourses.length > 0">
              <dl v-for="item in relativeCourses" v-bind:key="item.id" @click="course_detail(item.id)">
                <a href="javascript:;">
                  <dt>
                    <img v-if="item.faceUrl" :src="item.faceUrl" :title="item.name" />
                    <img v-if="!item.faceUrl || item.faceUrl==''" src="@/assets/images/class_img.jpg" :title="item.name" />
                    <span class="price_r" v-if="item.coursePriceList && item.coursePriceList[0].price && item.coursePriceList[0].price != '0'">￥{{item.coursePriceList[0].price}}</span>
                    <span class="price_r" v-if="!item.coursePriceList || !item.coursePriceList[0].price || item.coursePriceList[0].price == '0'">免费</span>
                    <span class="man_num_r">{{item.learnCount}}</span>
                  </dt>
                  <dd>
                    <h3>{{item.name}}</h3>
                    <p v-if="item.teacherList && item.teacherList.length>0">讲师：{{item.teacherList[0].teacherName}}</p>
                    <p v-if="!item.teacherList">讲师：暂无</p>
                  </dd>
                </a>
              </dl>
            </div>
            <h5 class="none_ts" v-if="relativeCourses.length == '0'">
              暂无相关课程推荐
            </h5>
          </div>
        </div>
      </div>
    </div>
    <!--/推荐课程滚动-->
    <v-dialog/>
    <!--评分-->
    <div class="tan_pf kc_star" style="display:none;">
      <div class="add_con_pf" style="height:170px;">
        <h4>请对本课程作出评分</h4>
        <div id="startone"  class="block clearfix" >
          <div class="star_score"></div>
          <p style="float:left;"> 评分：<span class="fenshu"></span> 分</p>

        </div>
        <!--<div id="startone2"  class="block clearfix" >
          <div class="star_score"></div>
          <p style="float:left;"> 教学易懂：<span class="fenshu"></span> 分</p>

        </div>
        <div id="startone3"  class="block clearfix" >
          <div class="star_score"></div>
          <p style="float:left;">逻辑清晰：<span class="fenshu"></span> 分</p>
        </div>-->
        <dl>
          <input type="button" value="取消" @click="$utils.fadeOut('.kc_star')" class="btn_pj" />　　<input type="button" value="确定" class="btn_pj red_color_b" @click="evaluate(params.id)" /></dl>
      </div>
    </div>
    <!--/评分-->
    <!--学习页面弹出-->
    <div class="tan courseLearn" style="display:none; z-index:9999 !important">
      <div class="px_add_con rp_add_con" style="height:500px;">
        <div class="h370 rdiv" style="height:500px;">
          <h3>{{params.name}}</h3>
          <a  href="javascript:void(0);"  class="close" @click="closeViewModal()" ></a>
          <div class="h200" style="overflow-x:hidden;height:480px;">
            <div  class="video_con" style="padding-top:10px;height:420px;">
              <!--视频-->
              <video-player  class="video-player-box"
                             ref="videoPlayer"
                             :options="playerOptions"
                             :playsinline="true"
                             customEventName="customstatechangedeventname"
                             @timeupdate="onPlayerTimeupdate($event)"
                             @ended="onPlayerEnded($event)"
                             @play="onPlayerPlay($event)"
                             @pause="onPlayerPause($event)"
                             @ready="playerReadied">
              </video-player>
              <!--@timeupdate="onPlayerTimeupdate($event)"-->
              <!--/视频-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/资源预览弹出-->
  </div>
</template>
<script>
import {init} from '@/assets/js/public'
import {scoreFun} from '@/assets/js/starScore'
import Paginate from 'vuejs-paginate'
import { getCookie } from '@/store/cookies.js'
import urlutils from '@/utils/urlencode'
import ModalBox from '@/components/common/modal/index.vue'
import QuizContainer from '@/page/modules/course/quizContainer'
import QuizResultContainer from '@/page/modules/course/quizResultContainer'
import rangePermission from '@/utils/rangePermission'
import config from '@/config'
// require styles
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  components: { Paginate, videoPlayer },
  data () {
    return {
      orgType: null,
      originPath: window.location.href,
      ori_str: '',
      params: {
        coursePriceList: [{}],
        teacherList: [{teacherName: ''}],
        chapterList: []
      },
      lastLearnChapter: {},
      filter: {
        pageNo: 1,
        pageSize: 4,
        teacherIds: []
      },
      evaluateFilter: {
        pageNo: 1,
        pageSize: 8,
        delFlag: '0'
      },
      resource: {},
      evaluateList: [],
      courseChapterList: [],
      evaluateCnt: 0,
      relativeCourses: [],
      teacherList: [],
      chLearnList: [],
      classificationName: '',
      isCollect: false,
      isEvaluate: false,
      evaluateRecord: {},
      avgStar: null,
      courseBuyStatus: '0', // '0' 无支付记录；'1' 支付成功；'2' 未支付
      currentPage: 1,
      pages: 0,
      evaluatePages: 0,
      learnCnt: 0,
      hasLearned: 0,
      allLearnCnt: 0,

      // 学习参数
      timeCell: 600,
      updateTime: 0,
      isChangeProgress: '1',
      playerOptions: {
        // videojs options
        muted: false,
        width: 640,
        height: 400,
        language: 'en',
        playbackRates: [1.0],
        sources: [{
          type: "video/mp4",
          src: "http://vod.bylonline.cn/9fc0cb5a737f4e08b93b3d360340dfff/a09f29b95fbd4249b74e7073dbf537e6-734884e784050aa4f71eae0abec3e9cb-ld.mp4"
        }],
        poster: "",
        controlBar: {
          remainingTimeDisplay: true,
          fullscreenToggle: true
        }
      },
      chapterItem: {},
      firstPlay: true
    }
  },
  created () {
    if (getCookie('org') && getCookie('org').businessId) {
      this.orgType=getCookie('org').businessId
      this.ori_str = this.$utils.judgementOri(this.orgType)
    } else {
      this.ori_str = ''
    }
    rangePermission.checkScope({ // 防盗链
      itemId: this.$route.params.id,
      itemType: '00',
      permission: '02'
    }).then((r) => {
      if (!r.data) {
        let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
        window.location.href = path
      }
    })
    this.course_buy_status(this.$route.params.id)
    this.getCourseByUser(this.$route.params.id)
    this.ori_str = this.$utils.judgementOri(this.orgType)
  },
  mounted () {
    this.$nextTick(() => {
      init()
      this.starScore()
    })
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    },
    boxMargin () {
      if (this.ori_str == 'entrain') {
        return {
          marginTop: '121px'
        }
      }
    },
    isLogined () {
      return !!getCookie(process.env.TOKEN_KEY)
    }
  },
  methods: {
    // listen event
    onPlayerPlay (player) {
      if (this.isChangeProgress=='0' && this.chapterItem.status!='2') {
        $('.vjs-progress-control').css('display', 'none')
      } else {
        $('.vjs-progress-control').css('display', 'flex')
      }
      if (this.firstPlay) {
        if (this.chapterItem.per==100) {
          player.currentTime(0)
          this.updateTime = 0
        } else {
          player.currentTime(this.chapterItem.learnHour)
          this.updateTime = parseInt(this.chapterItem.learnHour)
        }
        this.firstPlay = false
      }
    },
    onPlayerPause (player) {
      this.learnChapter(this.chapterItem.courseId, this.chapterItem.id, this.chapterItem.chapterLearnId, player.currentTime())
    },
    onPlayerEnded (player) {
      this.learnChapter(this.chapterItem.courseId, this.chapterItem.id, this.chapterItem.chapterLearnId, this.resource.length)
      this.$modal.show('dialog', {
        title: '提示',
        text: '该课程章节已经结束！',
        buttons: [
          {
            title: '确定',
            default: true,
            handler: () => {
              this.$modal.hide('dialog')
              this.closeViewModal()
            }
          }
        ]
      })
    },
    // ...player event
    onPlayerTimeupdate (player) {
      let currentTime = player.currentTime()
      if (currentTime > this.updateTime) {
        this.learnChapter(this.chapterItem.courseId, this.chapterItem.id, this.chapterItem.chapterLearnId, currentTime)
        this.updateTime = this.updateTime + this.timeCell
      }
    },
    // player is ready
    playerReadied (player) {
    },
    clickCallback (pageNum) {
      this.evaluateFilter.pageNo = pageNum
      this.getAllEvaluate(this.evaluateFilter)
    },
    page_click (type) {
      if (type=='prev') {
        if (this.currentPage > 1) {
          this.filter.pageNo = this.currentPage - 1
          this.currentPage--
          this.getRelativeCourse(this.filter)
        }
      } else if (type=='next') {
        if (this.currentPage < this.pages) {
          this.filter.pageNo = this.currentPage + 1
          this.currentPage++
          this.getRelativeCourse(this.filter)
        }
      }
    },
    dealHighLight (arr) {
      if(arr && arr.length>0) {
        var arrLength = arr.length;
        var index = 0;
        for(let m=0; m<arr.length; m++){
          if(arr[m].lastLearnLog == '0'){
            index++;
            continue;
          }
        }
        if (arrLength == index) {
          arr[0].lastLearnLog = '1';
        } else{
          for(let i=0; i<arr.length; i++){
            if(arr[i].sourceList){
              if (arr[i].lastLearnLog == '1' && (arr[i].status && arr[i].status == '2') && (i < arrLength - 1)) {
                arr[i].lastLearnLog = '0';
                arr[i+1].lastLearnLog = '1';
              }
            }else if(arr[i].examList){
              if (arr[i].lastLearnLog == '1' && (arr[i].pass && arr[i].pass == '1') && (i < arrLength - 1)) {
                arr[i].lastLearnLog = '0';
                arr[i+1].lastLearnLog = '1';
              }
            }
          }
        }
      }
    },
    getCourseByUser (id) {
      this.$api.post(this.$global.bylApiPath, '/course/chapter/info', {id: id}, r => {
        if (r.data) {
          this.params = r.data
          if (this.params.chapterInfos) {
            this.courseChapterList = this.params.chapterInfos
            this.dealHighLight(this.courseChapterList)
            for (let i = 0; i < this.courseChapterList.length; i++) {
              if (this.courseChapterList[i].lastLearnLog == '1') {
                this.lastLearnChapter = this.courseChapterList[i]
              }
            }
          }

          if (this.params.isChangeProgress) {
            this.isChangeProgress = this.params.isChangeProgress
          }
          this.learnCnt = this.params.learnCount
          this.getCourseClassification(this.params.courseClassifiId)
          this.getCollect(this.params.id)
          this.filter.teacherIds = []
          if (this.params.teacherList && this.params.teacherList.length>0) {
            for (let i=0; i<this.params.teacherList.length; i++) {
              this.filter.teacherIds.push(this.params.teacherList[i].teacherId)
            }
            this.getRelativeCourse(this.filter)
            this.getTeacherListByIds(this.filter.teacherIds)
          }
          this.getAllEvaluate(this.params.id)
          if (getCookie(process.env.TOKEN_KEY)) {
            this.getEvaluate(this.params.id)
          }
          this.hasLearned = 0
          this.allLearnCnt = 0
          // this.getCourseLearnLog(this.params.id)
          if (this.courseChapterList && this.courseChapterList.length>0) {
            for (let i=0; i<this.courseChapterList.length; i++) {
              if (this.courseChapterList[i].status == '2') {
                this.hasLearned++
              }
            }
            for (let i = 0; i < this.courseChapterList.length; i++) {
              if (this.courseChapterList[i].status == '1' || this.courseChapterList[i].status == '2') {
                this.allLearnCnt++
              }
            }
          }
        }
      })
    },
    learnChapter (courseId, chapterId, chapterLearnId, learnHour) {
      this.$api.post(this.$global.bylApiPath, '/course/learn', {courseId: courseId, chapterId: chapterId, id: chapterLearnId, learnHour: learnHour}, r => {
        if (r.data) {
          this.chapterItem.learnHour = r.data.learnHour
        }
      })
    },
    getChapterResource (courseInfo, chapterItem) {
      if (chapterItem.examList) {
        this.showQuiz(chapterItem);
      } else if (chapterItem.sourceList) {
        this.$api.post(this.$global.bylApiPath, '/learn/check/chapter/learnAuth', {
          courseId: chapterItem.courseId,
          chapterId: chapterItem.id
        }, r => {
          this.$api.get(this.$global.resourceApiPath, '/resource/view/' + chapterItem.sourceList[0].sourceId, {}, r => {
            this.resource = r.data
            this.chapterItem = chapterItem
            this.$refs.videoPlayer.player.src(this.resource.filePathMp4)
            this.firstPlay = true
            this.$utils.fadeIn('.courseLearn')
          })
        })
      }

    },
    closeViewModal () {
      this.$utils.fadeOut('.courseLearn')
      this.$refs.videoPlayer.player.pause()
      this.getCourseByUser(this.$route.params.id)
    },
    course_detail (id) {
      var path = (getCookie('org')) ? this.$OR.getUrl(getCookie('org').businessId) : ''
      this.$router.push({
        path: path + '/courseDetail/' + id
      })
    },
    teacher_detail (id) {
      var path = (getCookie('org')) ? this.$OR.getUrl(getCookie('org').businessId) : ''
      this.$router.push({
        path: path + '/teacherDetail/' + id
      })
    },
    getRelativeCourse (filter) {
      this.$api.post(this.$global.courseApiPath, '/course/courses/teacher/page', filter, r => {
        if (r.data) {
          this.relativeCourses = r.data
          this.pages = Math.ceil(r.cntData / this.filter.pageSize)
        }
      })
    },
    getCourseClassification (id) {
      this.$api.getRestful(this.$global.courseApiPath, '/course/classification/' + id, {}, r => {
        this.classificationName = r.data.name
      })
    },
    getCollect (courseId) {
      this.$api.post(this.$global.courseApiPath, '/course/collect/collects', {courseId: courseId, delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
         this.isCollect = true
        } else {
          this.isCollect = false
        }
      })
    },
    // teachers
    getTeacherListByIds (idsArr) {
      let idStr = ''
      if (idsArr && idsArr.length>0) {
        for (let i = 0; i<idsArr.length; i++) {
          if (i<idsArr.length-1) {
            idStr += idsArr[i] + ','
          } else if (i == idsArr.length-1) {
            idStr += idsArr[i]
          }
        }
      }
      this.$api.get(this.$global.teacherApiPath, '/teacher/batch', {ids: idStr}, r => {
        this.teacherList = r.data
      })
    },
    course_buy_status (id) {
      this.$api.post(this.$global.courseApiPath, '/course/buy/buys', {courseId: id, delFlag: '0'}, r => {
        if (r.data) {
          this.courseStatus = r.data
          this.courseBuyStatus = this.courseStatus[0].status
        } else {
          this.courseBuyStatus = '0'
        }
      })
    },
    course_buy (id) {
      if (getCookie(process.env.TOKEN_KEY)) {
        this.$api.post(this.$global.courseApiPath, '/course/buy/buys', {courseId: id, delFlag: '0'}, r => {
          if (r.data) {
            this.courseStatus = r.data
            this.courseBuyStatus = this.courseStatus[0].status
          } else {
            this.courseBuyStatus = '0'
          }
          if (this.courseBuyStatus == '0') {
            this.$api.post(this.$global.courseApiPath, '/course/buy/add', {courseId: id, price: this.params.coursePriceList[0].price}, r => {
              if (r.data) {
                this.$router.push({path: '/'+ this.ori_str +'/coursePay/'+ id + '/' + '3'+ '/'  + r.data.id + '/' + this.orgType + '/' + urlutils.url_coded(this.originPath) +  '/'  + r.data.priceSign})
              }
            })
          } else if (this.courseBuyStatus == '1') {
            this.$toasted.show('您已支付成功，无需再支付！', {
              duration: 800
            })
            this.getCourseByUser(id)
          } else if (this.courseBuyStatus == '2') {
            let that = this
            this.$modal.show('dialog', {
              title: '支付',
              text: '该课程存在未完成支付订单，是否继续支付？',
              buttons: [
                {
                  title: '继续',
                  default: true,
                  handler: () => {
                    that.$router.push({path: '/'+ that.ori_str +'/coursePay/'+ id + '/' + '3'+ '/'  + that.courseStatus[0].id + '/' + that.orgType + '/' + urlutils.url_coded(that.originPath)+ '/'  + that.courseStatus[0].priceSign})
                  }
                },
                {
                  title: '取消订单',
                  handler: () => {
                    this.$api.post(this.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: that.courseStatus[0].id}, r => {
                      this.$api.getRestful(this.$global.courseApiPath, '/course/buy/delete/' + that.courseStatus[0].id, {}, r => {
                        that.$modal.hide('dialog')
                        that.$toasted.show('订单取消成功！', {
                          duration: 800
                        })
                        that.course_buy_status(id)
                      }, e => {
                        this.$toasted.show(e.message, {
                          duration: 800
                        })
                      })
                    }, e => {
                      if (e=='PAY_ERROR_00014') {
                        that.$modal.hide('dialog')
                        that.course_buy_status(id)
                        that.getCourseByUser(id)
                      }
                    })
                  }
                }
              ]
            })
          }
        })
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    },
    course_collectOrCancel (courseId, event) {
      if (getCookie(process.env.TOKEN_KEY)) {
        let curClass = $(event.target).attr('class')
        if (curClass == 'fav') {
          this.$api.post(this.$global.courseApiPath, '/course/collect', {courseId: courseId}, r => {
            this.isCollect = true
            this.$toasted.show('收藏成功！', {
              duration: 800
            })
          })
        } else if (curClass == 'fav_focus') {
          this.$api.post(this.$global.courseApiPath, '/course/collect/collects', {courseId: courseId, delFlag: '0'}, r => {
            if (r.data && r.data.length>0) {
              this.$api.getRestful(this.$global.courseApiPath, '/course/collect/delete/' + r.data[0].id, {}, r => {
                this.isCollect = false
                this.$toasted.show('取消收藏成功！', {
                  duration: 800
                })
              })
            }
          })
        }
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    },
    starScore () {
      scoreFun($("#startone"))
    },
    showEvaluate (status) {
      if (getCookie(process.env.TOKEN_KEY)) {
        if (!status) {
          this.$utils.fadeIn('.kc_star')
        } else {
          this.$toasted.show('您已经对该课程进行评价！', {
            duration: 800
          })
        }
      } else {
        this.$toasted.show('请先登录！', {
          duration: 800
        })
      }
    },
    evaluate (courseId) {
      let score = $('#startone>p>span').text()
      this.$utils.fadeOut('.kc_star')
      this.$api.post(this.$global.bylApiPath, '/course/comment', {courseId: courseId, star: score}, r => {
        this.isEvaluate = true
        this.$toasted.show('课程评价成功！', {
          duration: 800
        })
        this.getEvaluate()
      })
    },
    getEvaluate (courseId) {
      this.$api.post(this.$global.courseApiPath, '/comment/page/comments', {courseId: courseId, delFlag: '0'}, r => {
        if (r.data && r.data.length>0) {
          this.isEvaluate = true
          this.evaluateRecord = r.data[0]
        } else {
          this.isEvaluate = false
          this.evaluateRecord = {}
        }
      })
    },
    getAllEvaluate (courseId) {
      this.evaluateFilter.courseId = courseId
      this.$api.post(this.$global.bylApiPath, '/page/comments', this.evaluateFilter, r => {
        this.evaluateCnt = r.cntData
        if (r.data && r.data.length>0) {
          this.evaluatePages = Math.ceil(r.cntData / this.evaluateFilter.pageSize)
          this.evaluateList = r.data
          this.avgStar = this.evaluateList[0].avgStar
        }
      })
    },
    showStar (starNum) {
      let starHtml = ''
      for (let i=1; i<=starNum; i++) {
        starHtml += '<a class="star_a"></a>'
      }
      for (let i=1; i<=5-starNum; i++) {
        starHtml += '<a class="star_b"></a>'
      }
      return starHtml
    },
    continueLearn() {
      if (getCookie(process.env.TOKEN_KEY)) {
        var target_top = $('#study_detail_content').offset().top;
        $("html,body").animate({scrollTop: target_top}, 600);
        $(".tab_content > div").hide();
        $(".tabs").each(function () {
          $(this).find("li:first a").removeClass("current");
        })
        $(".tabs").find("li.tab1_3>a").addClass("current")
        $(".tab_content > div.tab1_5").show()
        this.getChapterResource(this.params, this.lastLearnChapter)
      } else {
        this.$toasted.show('请登录后再进行课程学习！', {
          duration: 800
        })
      }
    },
    showQuiz (item) {
      if (getCookie(process.env.TOKEN_KEY)) {
        var that = this
        this.$api.post(this.$global.bylApiPath, '/learn/check/chapter/learnAuth', {courseId: item.courseId, chapterId: item.id}, r => {
          this.$modal.show(ModalBox, {
            opts: {
              title: '小测验',
              styles: {
                width: '812',
                height: String(0.6209 * window.screen.availHeight)
              },
              offEdit: true, // 是否包含"确定"与"取消"按钮
              currentComponent: {
                name: 'QuizBox',
                template: QuizContainer,
                outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
                inputs: {
                  paperId: item.examList[0].examId,
                  chapterId: item.examList[0].chapterId,
                  courseId: item.examList[0].courseId
                }
              },
              closed () {
                that.getCourseByUser(that.$route.params.id)
              }
            }
          })
        })
      } else {
        this.$toasted.show('请登录后再进行课程学习！', {
          duration: 800
        })
      }
    },
    showQuizResult (item) {
      if (getCookie(process.env.TOKEN_KEY)) {
        var that = this
        this.$modal.show(ModalBox, {
          opts: {
            title: '测验结果',
            styles: {
              width: '812',
              height: String(0.6209 * window.screen.availHeight)
            },
            offEdit: true, // 是否包含"确定"与"取消"按钮
            currentComponent: {
              name: 'QuizResultBox',
              template: QuizResultContainer,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                paperId: item.examList[0].examId,
                chapterId: item.examList[0].chapterId,
                courseId: item.examList[0].courseId,
                examId: item.examId
              }
            },
            closed () {
            }
          }
        })
      } else {
        this.$toasted.show('请登录后再进行课程学习！', {
          duration: 800
        })
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.getCourseByUser(to.params.id)
      this.course_buy_status(to.params.id)
    }
  }
}
</script>
<style lang="scss" scoped>
  .back_btn {
    position: absolute;
    top: 16px;
    right: 137px;
    width: 56px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    border-radius: 5px;
    color: #333;
    display: block;
    background: #fff;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  .focus_item{color:#000 !important; font-weight:bold}
</style>



// WEBPACK FOOTER //
// src/page/modules/course/detail.vue